import { render, staticRenderFns } from "./MenuItensSimples.vue?vue&type=template&id=e0d41514&scoped=true"
import script from "./MenuItensSimples.vue?vue&type=script&lang=js"
export * from "./MenuItensSimples.vue?vue&type=script&lang=js"
import style0 from "./MenuItensSimples.vue?vue&type=style&index=0&id=e0d41514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d41514",
  null
  
)

export default component.exports